import { useState } from 'react';
import { useEquipo } from '../../context/EquipoContext';

export default function RegistroResultado({ partido, onNext, onCancelar }) {
  const { deporteActivo } = useEquipo();
  const esFutbol = !deporteActivo || deporteActivo === 'futbol';

  const [golesLocal,     setGolesLocal]     = useState('');
  const [golesVisitante, setGolesVisitante] = useState('');
  const [sets, setSets] = useState([{ local: '', visitante: '' }]);
  const [error, setError] = useState('');

  const agregarSet = () => {
    if (sets.length < 3) setSets(prev => [...prev, { local: '', visitante: '' }]);
  };
  const quitarSet = (i) => {
    if (sets.length > 1) setSets(prev => prev.filter((_, idx) => idx !== i));
  };
  const updateSet = (i, campo, valor) => {
    setSets(prev => prev.map((s, idx) => idx === i ? { ...s, [campo]: valor } : s));
  };

  const calcularGanadorSets = () => {
    let setsLocal = 0, setsVisitante = 0;
    for (const s of sets) {
      const l = Number(s.local);
      const v = Number(s.visitante);
      if (l > v) setsLocal++;
      else if (v > l) setsVisitante++;
    }
    return { setsLocal, setsVisitante };
  };

  const handleNext = () => {
    if (esFutbol) {
      if (golesLocal === '' || golesVisitante === '') {
        setError('Ingresa el marcador completo'); return;
      }
      if (Number(golesLocal) < 0 || Number(golesVisitante) < 0) {
        setError('El marcador no puede ser negativo'); return;
      }
      const ganamos = Number(golesLocal) > Number(golesVisitante);
      const empate  = Number(golesLocal) === Number(golesVisitante);
      onNext({ golesLocal: Number(golesLocal), golesVisitante: Number(golesVisitante), ganamos, empate });
    } else {
      for (let i = 0; i < sets.length; i++) {
        if (sets[i].local === '' || sets[i].visitante === '') {
          setError(`Completa el marcador del set ${i + 1}`); return;
        }
      }
      const { setsLocal, setsVisitante } = calcularGanadorSets();
      if (setsLocal === setsVisitante) {
        setError('No puede haber empate en sets — revisa el marcador'); return;
      }
      const ganamos = setsLocal > setsVisitante;
      const resultado_detalle = {
        tipo: 'sets',
        sets: sets.map(s => ({ local: Number(s.local), visitante: Number(s.visitante) })),
        ganador: ganamos ? 'local' : 'visitante',
      };
      onNext({ golesLocal: setsLocal, golesVisitante: setsVisitante, ganamos, empate: false, resultado_detalle });
    }
  };

  const { setsLocal, setsVisitante } = esFutbol ? {} : calcularGanadorSets();

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Registrar resultado</h2>
      <p style={styles.sub}>
        {esFutbol
          ? 'Ingresa el marcador final del partido.'
          : `Ingresa el marcador de cada set. Mejor de 3 sets.`}
      </p>

      <div style={styles.partidoHeader}>
        <div style={styles.equipoWrap}>
          <div style={{ ...styles.crest, background: `linear-gradient(135deg, ${partido.colorPrincipal || '#FF6B1A'}, ${partido.colorSecundario || '#1A6BFF'})` }}>
            {partido.inicialesLocal || 'LB'}
          </div>
          <div style={styles.equipoNombre}>{partido.local || 'Mi equipo'}</div>
        </div>

        {esFutbol ? (
          <div style={styles.marcadorWrap}>
            <input type="number" value={golesLocal} onChange={e => { setGolesLocal(e.target.value); setError(''); }}
              placeholder="0" style={styles.inputGol} min="0" max="99" />
            <div style={styles.vs}>–</div>
            <input type="number" value={golesVisitante} onChange={e => { setGolesVisitante(e.target.value); setError(''); }}
              placeholder="0" style={styles.inputGol} min="0" max="99" />
          </div>
        ) : (
          <div style={{ fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, textAlign: 'center' }}>
            {setsLocal !== undefined && (setsLocal > 0 || setsVisitante > 0)
              ? `${setsLocal} – ${setsVisitante} sets`
              : 'Sets'}
          </div>
        )}

        <div style={styles.equipoWrap}>
          <div style={{ ...styles.crest, background: `linear-gradient(135deg, ${partido.color1Rival || '#1A6BFF'}, ${partido.color2Rival || '#0F4FCC'})` }}>
            {partido.inicialesRival || 'GS'}
          </div>
          <div style={styles.equipoNombre}>{partido.rival || 'Rival'}</div>
        </div>
      </div>

      {/* Sets para padel/tenis */}
      {!esFutbol && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10, fontFamily: "'Barlow', sans-serif" }}>
            Marcador por sets
          </div>
          {sets.map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <div style={{ fontSize: 12, color: '#9BA5B7', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, width: 44 }}>
                Set {i + 1}
              </div>
              <input type="number" value={s.local} onChange={e => { updateSet(i, 'local', e.target.value); setError(''); }}
                placeholder="0" style={styles.inputSet} min="0" max="7" />
              <div style={styles.vs}>–</div>
              <input type="number" value={s.visitante} onChange={e => { updateSet(i, 'visitante', e.target.value); setError(''); }}
                placeholder="0" style={styles.inputSet} min="0" max="7" />
              {sets.length > 1 && (
                <button onClick={() => quitarSet(i)} style={styles.btnQuitarSet}>✕</button>
              )}
            </div>
          ))}
          {sets.length < 3 && (
            <button onClick={agregarSet} style={styles.btnAgregarSet}>+ Agregar set</button>
          )}
        </div>
      )}

      {(() => {
        const mostrar = (esFutbol && golesLocal !== '' && golesVisitante !== '') ||
          (!esFutbol && setsLocal !== undefined && setsLocal + setsVisitante > 0 && setsLocal !== setsVisitante);
        if (!mostrar) return null;
        const victoria = esFutbol ? Number(golesLocal) > Number(golesVisitante) : setsLocal > setsVisitante;
        const empate   = esFutbol && Number(golesLocal) === Number(golesVisitante);
        const bg     = victoria ? 'rgba(22,163,74,0.1)'   : empate ? 'rgba(107,114,128,0.1)' : 'rgba(239,68,68,0.1)';
        const border = victoria ? '#86EFAC'                : empate ? '#D1D5DB'                : '#FCA5A5';
        const color  = victoria ? '#16A34A'                : empate ? '#6B7280'                : '#EF4444';
        const texto  = victoria ? '🏆 ¡Victoria!' : empate ? '🤝 Empate' : '😔 Derrota';
        return (
          <div style={{ ...styles.previewResultado, background: bg, borderColor: border }}>
            <div style={{ ...styles.previewTexto, color }}>{texto}</div>
          </div>
        );
      })()}

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnCancelar} onClick={onCancelar}>Cancelar</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4 },
  sub: { fontSize: 13, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5 },
  partidoHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 20, background: '#F4F6FA', borderRadius: 14, padding: '20px' },
  equipoWrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, flex: 1 },
  crest: { width: 52, height: 52, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: 'white' },
  equipoNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700, color: '#141922', textAlign: 'center' },
  marcadorWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  inputGol: { width: 64, height: 64, background: 'white', border: '2px solid #E8ECF4', borderRadius: 12, textAlign: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 32, fontWeight: 800, color: '#141922', outline: 'none' },
  inputSet: { width: 52, height: 52, background: 'white', border: '2px solid #E8ECF4', borderRadius: 10, textAlign: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 24, fontWeight: 800, color: '#141922', outline: 'none' },
  vs: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 28, fontWeight: 800, color: '#9BA5B7' },
  btnAgregarSet: { background: 'white', border: '1.5px dashed #E8ECF4', borderRadius: 10, padding: '8px 16px', fontSize: 12, fontWeight: 700, color: '#9BA5B7', cursor: 'pointer', fontFamily: "'Barlow', sans-serif", width: '100%', marginTop: 4 },
  btnQuitarSet: { background: 'transparent', border: 'none', color: '#EF4444', fontSize: 14, cursor: 'pointer', padding: '4px 8px' },
  previewResultado: { border: '1.5px solid', borderRadius: 12, padding: '14px', textAlign: 'center', marginBottom: 20, transition: 'all 0.2s' },
  previewTexto: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800 },
  error: { color: '#EF4444', fontSize: 12, fontFamily: "'Barlow', sans-serif", marginBottom: 12 },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnCancelar: { padding: '13px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif" },
  btnNext: { padding: '13px', background: '#FF6B1A', border: 'none', borderRadius: 12, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer' },
};
